import React, { Component } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import "../Common/Common.css";
import { withRouter } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "./Dashboard.css";

var dateFormat = require("dateformat");

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,

      page: 0,
      perPage: 10
    };
  }

  componentDidMount() {
    this.props.fetchOrdersfromChemist(); //normalnew orders
    this.props.processednormalOrdersList(); //normal inprocess orders
    this.props.deliverednormalOrdersList(); //normal delivered orders
    this.props.cancellednormalOrdersList();

    this.props.fetchUrgentOrders(); //urgent new orders
    this.props.processedurgentOrdersList(); //urgent in process orders
    this.props.deliveredurgentOrdersList(); //urgent delivered orders
    this.props.cancelledurgentOrdersList();

    this.props.orderReturnList(); //sales return without specifying orgType

    this.props.supportTickets(); //support tickets for the distributor

    this.props.fetchCreditNotes(); //credit notes for the distributor

  }

  //For pagination
  handlePageClick = e => {
    const selectedPage = e.selected;
    // console.log(selectedPage);
    this.props.pageSelected(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  //Redirecting to corresponding pages
  gotonewUrgentOrders = () => {
    this.props.history.push({
      pathname: "/orders",
      activeTab: "new"
    });
  };

  gotoprocessingUrgentOrders = () => {
    this.props.history.push({
      pathname: "/orders",
      activeTab: "processing"
    });
  };

  gotocompletedUrgentOrders = () => {
    this.props.history.push({
      pathname: "/orders",
      activeTab: "complete"
    });
  };

  gotonewnormalOrders = () => {
    this.props.history.push({
      pathname: "/normal-orders",
      activeTab: "new"
    });
  };

  gotoprocessingnormalOrders = () => {
    this.props.history.push({
      pathname: "/normal-orders",
      activeTab: "processing"
    });
  };

  gotocompletednormalOrders = () => {
    this.props.history.push({
      pathname: "/normal-orders",
      activeTab: "complete"
    });
  };

  gotoReturns = () => {
    this.props.history.push("/salesreturns");
  };

  gotoCreditnotes = () => {
    this.props.history.push("/creditnotes");
  };

  gotoSupport = () => {
    this.props.history.push("/support");
  };

  gotocancellUrgentOrders = () => {
    this.props.history.push({
      pathname: "/orders",
      activeTab: "cancel"
    });
  };

  gotocancellnormalOrders = () => {
    this.props.history.push({
      pathname: "/normal-orders",
      activeTab: "cancel"
    });
  };

  handleClose = () => {
    this.setState({
      modalTitle: "",
      showModal: false,
      modalArray: []
    });
  };

  render() {
    const count = this.props.urgentOrdersCount;
    let p = this.state.page + 1;
    let urgentOrdersPageCount = Math.ceil(count / this.state.perPage);

    //Destructuring
    const {
      gotonewUrgentOrders,
      gotoprocessingUrgentOrders,
      gotocompletedUrgentOrders,
      gotonewnormalOrders,
      gotoprocessingnormalOrders,
      gotocompletednormalOrders,
      gotoReturns,
      gotoCreditnotes,
      gotoSupport,
      gotocancellUrgentOrders,
      gotocancellnormalOrders
    } = this;
    const {
      processedurgentOrdersListCount,
      deliveredurgentOrdersListCount,
      newnormalOrdersListCount,
      processednormalOrdersListCount,
      deliverednormalOrdersListCount,
      cancellnormalOrdersListCount,
      cancellurgentOrdersListCount,
      orderReturnListCount,
      supportTicketsListCount,
      urgentOrdersCount,
      urgentOrders,
      creditNotesCount
    } = this.props;

    return (
      <div className="dashbordfrstdiv">
        <Card className="urgentdashcard">
          <h3 className="urgentdash">Urgent Orders</h3>
        </Card>

        <Row>
          {/* <h3 className="normaldash">Urgent Orders</h3> */}
          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotonewUrgentOrders}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">New</h5>
                      {/* <h5 className="dashboardfrst">
                        {" "}
                        Urgent Orders {""}
                        <span className="dashboardtext">New</span>
                      </h5> */}
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {urgentOrdersCount ? urgentOrdersCount : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-bolt fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card
              className="dashboardCards"
              onClick={gotoprocessingUrgentOrders}
            >
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">In Progress</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {processedurgentOrdersListCount
                        ? processedurgentOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-spinner fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card
              className="dashboardCards"
              onClick={gotocompletedUrgentOrders}
            >
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Completed</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {deliveredurgentOrdersListCount
                        ? deliveredurgentOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-check-square-o fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotocancellUrgentOrders}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Cancelled</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {cancellurgentOrdersListCount
                        ? cancellurgentOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-ban fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <div>
          <h3 className="normaldash">Normal Orders</h3>
        </div>

        <Row>
          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotonewnormalOrders}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">New</h5>
                      {/* <h5 className="dashboardfrst">
                        {" "}
                        Normal Orders {""}
                        <span className="dashboardtext">New</span>
                      </h5> */}
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {newnormalOrdersListCount ? newnormalOrdersListCount : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-truck fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card
              className="dashboardCards"
              onClick={gotoprocessingnormalOrders}
            >
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">In Progress </h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {processednormalOrdersListCount
                        ? processednormalOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-spinner fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card
              className="dashboardCards"
              onClick={gotocompletednormalOrders}
            >
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Completed</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {deliverednormalOrdersListCount
                        ? deliverednormalOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-check-square-o fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotocancellnormalOrders}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Cancelled</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {cancellnormalOrdersListCount
                        ? cancellnormalOrdersListCount
                        : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-ban fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <h3 className="normaldashnxt"></h3>
        <Row>
          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotoReturns}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Sales Returns</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {orderReturnListCount ? orderReturnListCount : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className=" cui-action-undo fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotoCreditnotes}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Credit Notes</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {creditNotesCount ? creditNotesCount : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-credit-card-alt fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={3} sm={12} xs={12}>
            <Card className="dashboardCards" onClick={gotoSupport}>
              <Card.Body>
                <Row>
                  <Col lg={8} md={8} sm={12} xs={12}>
                    <Card.Title>
                      <h5 className="dashboardtext">Support Tickets</h5>
                    </Card.Title>
                    <Card.Text className="dashboardcounttext">
                      {supportTicketsListCount ? supportTicketsListCount : 0}
                    </Card.Text>
                  </Col>
                  <Col lg={4} md={4} sm={12} xs={12}>
                    <div className="dashboradicon">
                      <div className="avatar-title rounded-circle dashboradroundcolor">
                        <i className="fa fa-life-ring fa-lg dashboradroundicon "></i>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={3} sm={12} xs={12}></Col>
        </Row>
        {urgentOrdersCount > 0 && (
          <div className="dashboadtabdiv">
            <Card>
              <div className="salesheader">
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <h5 className="tablecardtitle">Urgent Orders</h5>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}></Col>

                  <Col xs={12} sm={12} md={3} lg={3}></Col>
                  <Col xs={12} sm={12} md={3} lg={3}></Col>
                </Row>
              </div>

              <Card.Body className="tableCardBody">
                <div className="tablecommonCardBody">
                  <Table hover responsive className="">
                    <thead className="tablecommonCard">
                      <tr>
                        <th>#</th>
                        <th>Order No</th>
                        <th>Chemist Name</th>
                        <th>Organization Name</th>
                        <th>Payment Mode</th>
                        <th>City</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>
                    {urgentOrders.length > 0 &&
                      urgentOrders.map((item, i) => (
                        <tbody key={i} className="modalBody">
                          <tr>
                            <td>{10 * (p - 1) + i + 1}</td>
                            <td>{item && item.orderNo}</td>
                            <td>
                              {item && item.orderFrom && item.orderFrom.name}{" "}
                              {item && item.orderFrom && item.orderFrom.lName}
                            </td>
                            <td>{item && item.orderFromName}</td>
                            <td>{item && item.payMode}</td>
                            <td>{item && item.city}</td>
                            <td>
                              {item &&
                                dateFormat(item.createdAt, "mmm dS, yyyy")}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </Card.Body>
              {urgentOrdersPageCount > 1 ? (
                <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={this.state.page}
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={urgentOrdersPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination flex-wrap"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              ) : null}
            </Card>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Dashboard);
